















































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { DxPopup, DxToolbarItem } from 'devextreme-vue/popup';
import { DxScrollView } from 'devextreme-vue';
import notificationService from '@/services/notificationService';
import {
  DxForm,
  DxItem,
  DxSimpleItem,
  DxGroupItem,
  DxLabel,
  DxRequiredRule,
} from 'devextreme-vue/form';

import tasksRepository from '../tasksRepository';

@Component({
  components: {
    DxPopup,
    DxToolbarItem,
    DxScrollView,
    DxForm,
    DxItem,
    DxSimpleItem,
    DxGroupItem,
    DxLabel,
    DxRequiredRule,
  },
})
export default class TaskNotePopup extends Vue {
  @Prop({required: true})
  public taskId!: string;

  showPopup: boolean = false;
  saving: boolean = false;

  dto: ITaskCreateNoteCommand = {
    id: '',
    message: '',
  };

  public show() {
    this.showPopup = true;
  }

  public hide() {
    this.showPopup = false;
  }

  public async save() {
    try {
      this.saving = true;
      const form: any = this.$refs.form;
      const validationResult = form.instance.validate();

      if (validationResult.isValid) {
        const result = await tasksRepository.createNote(this.dto);
        this.$emit('input', result.data);
        setTimeout(() => {
          this.dto.message = '';
        }, 250);
        notificationService.saved();
        this.hide();
      } else {
        notificationService.invalidForm();
      }
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.saving = false;
    }
  }

  mounted() {
    this.dto.id = this.taskId;
  }

}
